import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import jwt from 'jwt-decode';
import { StorageService } from '../helper/storage-service';
import { useAppDispatch } from '../store';
import { authorizedOfficerActions } from '../store/authorizedOfficer';
import { userActions } from '../store/user';
import { companyActions } from '../store/company';
import { mapApiDataToStores } from '../helper/dataMapper';
import { FlowStage, flowActions } from '../store/flow';
import styles from '../assets/Login.module.css';
const { USER_INFORMATION_URL, TOKEN_NAME, AOF_URL, ERROR_URL,FORGOT_PASSWORD_URL, PCN_NUMBER, KYC_URL, PCN_DECRYPT_URL, STATUS_URL } = require('../helper/application-conf').default;
import MessageBanner from './MessageBanner';
import { useAuth } from '../hooks/useAuth';
import handleLoginFromAuth from '../hooks/loginHook';
import useAxiosBuyer from '../hooks/useAxiosBuyer';
import { messageService } from '../service/messageService';
import axios from 'axios';
import { OneIdentityService } from '../service/oneIdentityService';

const { ProgressCircle } = require('@americanexpress/dls-react');

const {
  PasswordInput, dlsBrightBlue, ButtonBase, Input, Checkbox, ButtonPrimary, Label
} = require('@americanexpress/dls-react');

const Login = (props: any) => {
  const { t } = useTranslation();
  const location = useLocation();
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const { setAuth } = useAuth() as any;
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [count, setCount] = useState(0);
  const [countBadCredentials, setCountBadCredentials] = useState(0);
  const [countAttemptsExceeded, setCountAttemptsExceeded] = useState(0);
  const [hasError, setHasError] = useState(false);
  const [hasBadCredentials, setHasBadCredentials] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasAttemptsExceeded, setHasAttemptsExceeded] = useState(false);
  const [maxAttemptsReached, setMaxAttemptsReached] = useState('');
  const [oneApSiteName, setoneApSiteName] = useState('');
  const [oneApPcnNo, setoneApPcnNo] = useState('');
  const [docError, setDocError] = useState(false);
  const [isDocUpload, setisDocUpload] = useState(false);
  const [displayLogin, setDisplayLogin] = useState(false);
  const { siteName } = props;
  const axiosBuyer = useAxiosBuyer();
  const docData = location.state?.data;
  const encrptedPCNNumber = docData?.pcn;
  const oneIdentityService = new OneIdentityService();

  const storage = new StorageService();
  const showError = (flag: boolean) => {
    setCount((c) => c + 1);
    setHasError(flag);
  };

  const showBadCredentials = (flag: boolean) => {
    setCountBadCredentials((c) => c + 1);
    setHasBadCredentials(flag);
  }
  const showAttemptsExceeded = (flag: boolean) => {
    setCountAttemptsExceeded((c) => c + 1);
    setHasAttemptsExceeded(flag);
  }
  useEffect(() => {
    appDispatch(flowActions.setStage(FlowStage.Login));
    decryptPCN();
  }, [appDispatch]);

  const handleOneIdentityFlow = (siteName: any, pcnNumber: any, isDBO: any, isCorpDBO: any) => {
    if (isDBO) {
      window.location.href = `${window.location.origin}/digital-onboarding`
    } else if (isCorpDBO) {
      window.location.href = `${window.location.origin}/digital-onboarding/corporate-ao`
    }
    else {
      window.location.href = `${oneIdentityService.oneIdentityURL()}?DestPage=${window.location.origin}/${siteName}/home?PCN=${pcnNumber}`
    }

  }

  const handleForgotPassword = async () => {
    navigate(FORGOT_PASSWORD_URL);
  };

  const fetchConfig = async (siteName: string, pcnNumber: any) => {
    await axios.get(
      `/${siteName}${STATUS_URL}`
    ).then((response: any) => {
      setIsLoading(false)
      const res = response && response.data? response.data : null
      if (res) {
        if (res.isOneIdentityEnabled) {
          handleOneIdentityFlow(
            siteName,
            pcnNumber,
            res.isDBO ? true : false,
            res.isCorpDBO ? true : false
          )
          setDisplayLogin(false)
        }
        else {
          setDisplayLogin(true)
        }
      }
      else {
        setDisplayLogin(true)
      }
    });
  }

  const decryptPCN = async () => {
    if (docData && docData.status && docData.status == 'docupload') {
      messageService.sendstepperToggle(false);
      setisDocUpload(true);
      setIsLoading(true);
      await axios.get(
        `${PCN_DECRYPT_URL}${encrptedPCNNumber}`
        ).then((response: any) => {
          if (response && response.data) {
            setoneApPcnNo(response.data?.data);
            fetchSiteNameHandler(response.data?.data);
          }
          else {
            setIsLoading(false);
            setDocError(true);
            setDisplayLogin(true)
          }
        }).catch(() => {
          setIsLoading(false);
          setDocError(true);
          setDisplayLogin(true)
        });
    } else {
      setIsLoading(false);
      setDocError(false);
      setDisplayLogin(true)
    }

  };

  const fetchSiteNameHandler = async (pcnNo : string) => {
      await axios.get(
        `${KYC_URL}${pcnNo}`
        ).then((response: any) => {
          if (response && response.data) {
            setIsLoading(false);
            setoneApSiteName(response.data?.data);
            fetchConfig(response.data?.data, pcnNo)
          }
          else {
            setIsLoading(false);
            setDisplayLogin(true)
            setDocError(true);
          }
        }).catch(() => {
          setIsLoading(false);
          setDisplayLogin(true)
          setDocError(true);
        });
  };

  const getBuyerInfo = () => {
    axiosBuyer.get(`${AOF_URL}${siteName}`
    ).then((getResponse) => {
      const [userInfo, authorizedOfficerInfo, companyInfo] = mapApiDataToStores(getResponse);
      const userStore: any = userInfo;
      const authorizedOfficerStore: any = authorizedOfficerInfo;
      const companyInfoStore: any = companyInfo;
      appDispatch(userActions.setUser(userStore));
      appDispatch(authorizedOfficerActions.setAuthorizedOfficer(authorizedOfficerStore));
      appDispatch(companyActions.setCompany(companyInfoStore));
      navigate(USER_INFORMATION_URL);
    }, (error) => {
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.errors[0].message === t('errors.submission_completed')) {
        const errorText = {message: error.response.data.errors[0].message};
        navigate(ERROR_URL, { state: { errorText } });
      } else {
        navigate(ERROR_URL);
      }
    });
  };

  const handleLogin = async () => {
    if (user && pwd) {
      const bodyFormData = new URLSearchParams();
      bodyFormData.append('customer', siteName);
      bodyFormData.append('username', user);
      bodyFormData.append('password', pwd);
      const siteNameValue = isDocUpload ? oneApSiteName : siteName;
      handleLoginFromAuth(siteNameValue, user, pwd).then((response: any) => {
        showError(false);
        const accessToken = response?.data?.data?.accessToken;
        const refreshToken = response?.data?.data?.refreshToken;
        const decodedToken = jwt(accessToken) as any;
          const role = {
            userId: decodedToken?.sub, emailId: decodedToken?.email, firstName: decodedToken?.given_name, lastName: decodedToken?.family_name, roleNames: ['ADMINISTRATOR'], originalRole: JSON.parse(decodedToken?.origin_customer_role),
          };
          setAuth({
            user, pwd, accessToken, refreshToken, role,
          });

        if (isDocUpload) {
           docUploadLoginHandler(response);
        }
        else {
          storage.setSession(TOKEN_NAME, JSON.stringify(response.data.data));
          setTimeout(() => {
            getBuyerInfo();
          }, 1);
        }
        setUser('');
        setPwd('');
      }, (error: { response: { status: number; data: { value: string; }; }; }) => {
        if (error.response && error.response.status === 400 && error.response.data && error.response.data.value === t('login.bad_credentials')) {
          showBadCredentials(true);
        } else if (error.response && error.response.status === 400 && error.response.data && error.response.data.value.toLowerCase().includes(t('login.max_attempts_reached'))) {
          setMaxAttemptsReached(error.response.data.value);
          showAttemptsExceeded(true);
        }
        else {
          showError(true);
        }
      });
    }
  };

  const docUploadLoginHandler = async (response: any) => {
    storage.setSessionDocUpload(TOKEN_NAME, JSON.stringify(response.data.data), oneApSiteName);
    const data = { pcnNumber: oneApPcnNo };
    storage.setSessionDocUpload(PCN_NUMBER, JSON.stringify(data), oneApSiteName);
    window.location.pathname = `/${oneApSiteName}`;
  }

  return (
    <div>
      { !isLoading && displayLogin ? (
        <div>
        { !docError ? (
        <div className="container">
          <div className="row pad-4-t">
            <div className="col-md-offset-4 col-md-4">
              <h5 className="heading-5 text-align-center">{t('login.header')}</h5>
            </div>
          </div>

          <span key={count}>
            <MessageBanner type="warning" messageText={t('genericError')} showMessage={hasError} />
          </span>
          <span key={countBadCredentials}>
            <MessageBanner type="warning" messageText={t('login.bad_credentials')} showMessage={hasBadCredentials} />
          </span>
          <span key={countAttemptsExceeded}>
            <MessageBanner type="warning" messageText={maxAttemptsReached} showMessage={hasAttemptsExceeded} />
          </span>
          <div className="row pad-3-t">
            <div className="col-md-offset-4 col-md-4">
              <Label id="userid-label" htmlFor="userid-input">
                {t('login.user_id')}
              </Label>
              <Input id="user-id-input" maxLength={254} placeholder={t('login.email_placeholder')} required={true} onChange={(e: any) => setUser(e.target.value)} />
            </div>
          </div>
          <div className="row pad-t">
            <div className="col-md-offset-4 col-md-4">
              <Label id="password-label" htmlFor="password-input">
                {t('login.password')}
              </Label>
              <PasswordInput
                id="login-password-input"
                hideButton="true"
                placeholder={t('login.password_placeholder')}
                onChange={(event: any) => {
                  setPwd(event.target.value);
                }}
              />
            </div>

          </div>
          <div className="row">
            <div className="col-md-offset-4 col-md-4 pad-1-tb">
              <Checkbox id="checkbox" label="Remember me" disabled={false} defaultChecked={false} indeterminate={false} />
            </div>
          </div>
          <div className="row">
            <div className="stack-1 flex flex-column col-md-offset-4 col-md-4 pad-1-b">
              <ButtonPrimary onClick={handleLogin} className={`${styles.fluid}`}>
                {t('login.login_button')}
              </ButtonPrimary>
            </div>
          </div>

          {!isDocUpload
          && (
          <div className="row pad-1-t">
            <div className="col-md-offset-4 col-md-4">
              <ButtonBase theme={dlsBrightBlue} onClick={handleForgotPassword}>
                <span>{t('login.forgot_password')}</span>
              </ButtonBase>
            </div>
          </div>
          )}
        </div>
        ) : (
          <div className="row text-align-center pad-4-tb">
              <h5 className="col-md-offset-3 col-md-6 heading-5 pad-4-tb">
                {t('errors.error_boundary_header')}
              </h5>
              <p className="col-md-offset-3 col-md-6 body-3">
                {t('errors.error_boundary_note')}
              </p>
           </div>

        )}
        </div>
      ) : (
        <div className="row text-align-center pad-4-t flex flex-justify-center">
          <ProgressCircle size="lg" />
        </div>
      )}
    </div>
  );
};

export default Login;
